import FieldValidator from "../field-validator/FieldValidator";
import HttpClient from "../client/httpclient";
import Loader from "../loading/loader";
import { loadReCaptcha, getRecaptcha } from "../../utils/helpers";
import { GATracking } from "../../utils/webtracking";
import 'regenerator-runtime/runtime';
import CharacterCounter from "../characters-counter/CharCounter";
import CheckboxMinRequired from "../field-validator/CheckboxMinRequired";

class RequestYourInterestForm {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.fieldsets = this.el.querySelectorAll(".sd-fieldset");
            this.validateButton = this.el.querySelectorAll(".sd-button--primary");
            this.validateButton.forEach((button) =>
                button.addEventListener("click", this.validate)
            );
            this.actionUrl = this.el.getAttribute("action");
            this.method = "POST";
            if (process.env.NODE_ENV === "development") {
                this.actionUrl = "/src/api/signup-api-response.json";
            }
            this.loaderEl = this.el.querySelector(".sd-loading");

            this.loader = new Loader(this.loaderEl);
            this.form = this.el.querySelector(".membership__form");

            this.countrySelector = document.querySelector('[name="CountryCode"]');
            this.countrySelector ? this.countrySelector.addEventListener("change", this.countryChange) : "";
            this.onEventChange = this.onEventChange.bind(this);
            this.onEventChange();

            // add initial event listener to the form inputs
            const recaptchaInputs = this.el.querySelectorAll(".sd-fieldset__input");
            [...recaptchaInputs].forEach((input) => {
                input.addEventListener('focus', loadReCaptcha, false);
            })

            this.charCounters = document.querySelectorAll('.textareaCount');
            this.charCounters.length > 0 ? new CharacterCounter(this.charCounters) : "" ;

            this.checkboxMinRequiredEl = document.querySelectorAll(".sd-checkbox__minimum-required");

        } catch (error) {
            console.log(error);
        }
    }

    validate = (event) => {
        event.preventDefault();

        this.scrollToMembership();

        if (this.loader) {
            this.loader.show();
            document.querySelector(".membership-form-submit").style.fontSize = "0px";
            document.getElementById("full-page-overlay").style.display = "block";
        }

        let checkBoxMinCheck = this.checkBoxMinValidaty(this.checkboxMinRequiredEl);

        if (this.checkValidity(this.fieldsets) && (checkBoxMinCheck === null || checkBoxMinCheck)) {
            GATracking.formValidation('error_tracking', 'membership', 'success');
            if (this.el.getAttribute("id") === 'membership__form'){
                this.submitForm();
            } else {
                this.el.submit();
            }
        } else {
            GATracking.formValidation('error_tracking', 'membership', 'fail');
            if (this.loader) {
                this.loader.hide();
                document.querySelector(".membership-form-submit").style.fontSize = "12px";
                document.getElementById("full-page-overlay").style.display = "none";
            }
        }
    }

    checkValidity = (fieldsets) => {
        const validatedFieldsets = [...fieldsets]
            .filter(item => {
                const checkbox = item.querySelector(".sd-fieldset__checkbox-check");
                // Exclude fieldsets containing checkboxes from validation
                if (checkbox) {
                    return false;
                }
                return item.querySelector(".sd-fieldset__item").style.display === "none" ? false : item;
            })
            .map((form) =>
            new FieldValidator(form).validate()
        );
        return validatedFieldsets.every((isValid) => !!isValid);
    }

    checkBoxMinValidaty = (checkBoxArr) => {
        let isCheckboxMinRequired = null;
        if(checkBoxArr.length > 0){
            isCheckboxMinRequired = new CheckboxMinRequired(checkBoxArr).isMinChecked();
        }
        return isCheckboxMinRequired;
    }

    submitForm = async () => {
        await getRecaptcha("inline-badge-membership", ".recaptchaResponseMembership")
        const data = new FormData(this.el);
        await HttpClient.AsyncPostRequest(this.actionUrl, data, this.method)
        .then(this.handleFormStatus);
    }

    handleFormStatus = (response) => {
        let form = this.el;
        if (response) {
            this.el.nextElementSibling.classList.remove("sd-form__status-error");
            this.el.nextElementSibling.classList.add("sd-form__status-success");
            this.el.nextElementSibling.innerHTML = response;
            GATracking.formValidation('form_submission', 'membership', 'success');
        }
        if (!response) {
            this.displayError(response);
        }
        if (this.loader) {
            this.loader.hide();
            document.querySelector(".membership-form-submit").style.fontSize = "12px";
            document.getElementById("full-page-overlay").style.display = "none";
        }
        form.remove();
    }

    scrollToMembership = () => {
        var element = document.getElementById('membership__content');

        if (element) {
            var offsetTop = element.offsetTop - 50;

            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }

    displayError = (response) => {
        GATracking.formValidation('form_submission', 'membership', 'fail');
        this.el.nextElementSibling.classList.remove("sd-form__status-success");
        this.el.nextElementSibling.classList.add("sd-form__status-error");
        this.el.nextElementSibling.innerHTML = "Something went wrong. Please try again or contact us.";
    }

    onEventChange() {
        this.fieldsets.forEach((field, index) => {
            const fieldEle = field.querySelector(".sd-fieldset__input");
            fieldEle && fieldEle.addEventListener("change", () => {
                if (fieldEle.name === "CountryCode") {
                    document.querySelector(".sd-phone-number-input__label").textContent = ("+" + fieldEle.selectedOptions[0].innerHTML.replace(/[^0-9]/g, ''));
                }

            })
        })
    }
}

export default RequestYourInterestForm;